<template>
  <div class="confirm-view">
    <b-container>
      <section class="section section--loader" v-if="searching">
        <loader size="large" :show_timing_slot="true" />
      </section>
      <section class="section" v-else>
        <b-row>
          <b-col md="10" offset-md="1">
            <confirm-content-block
              :confirm="confirm"
            />
          </b-col>
        </b-row>
      </section>
    </b-container>
  </div>
</template>

<script>
import {mapState} from "vuex"
import { service_handler } from '@src/services'
import ConfirmContentBlock from '@liveeps/components/views/content-blocks/confirm'

export default {
  name: 'confirm-view',

  components: {
    'confirm-content-block': ConfirmContentBlock,
  },

  props: {
    itinerary_id: String,
    confirm_code: String,
  },

  data() {
    return {
      confirm: {},
    }
  },

  computed: {
    ...mapState({
      // stato globale
      searching: state => state.searching,
    }),
  },

  created() {
  },

  mounted() {
    this.get_confirm()
  },

  methods: {
    get_confirm() {
      let params = {
        itinerary_id: this.itinerary_id,
        confirmcode: this.confirm_code
      }

      this.$store.commit('searching', true)

      service_handler(
        'confirm',
        params
      ).then(
        (success) => {
          this.confirm = success.data
          this.$store.commit('liveeps/selected_solution', success.data.epsVoucher.solution)
          this.$store.commit('liveeps/selected_property', {
            ...success.data.epsVoucher.property,
            ratings: success.data.epsVoucher.solution.property.details.ratings,
            location: success.data.epsVoucher.property,
          })
          setTimeout(() => {
            this.$store.commit('searching', false)
          }, 2000)
        },
        (error) => {
          this.log(error.response)
          this.confirm = {}
          this.$store.commit('searching', false)
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped>
</style>